import { render, staticRenderFns } from "./capitalInput.vue?vue&type=template&id=2baf2492&scoped=true&"
import script from "./capitalInput.vue?vue&type=script&lang=js&"
export * from "./capitalInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baf2492",
  null
  
)

export default component.exports